import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";
import FahrerKarte from "../components/FahrerKarte";

const WOCHENTAGE = ["", "Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
const WOCHENTAGE_LANG = ["", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];

// Lokales Kalenderdatum als "YYYY-MM-DD" – NICHT toISOString() verwenden,
// das konvertiert nach UTC und verschiebt das Datum in Deutschland um einen Tag.
function toLocalISO(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function datumFuerWochentag(wochentag, offset = 0) {
  // Gibt das nächste (oder übernächste) Datum zurück das auf diesen Wochentag fällt
  // wochentag: 1=Mo .. 7=So
  const heute = new Date();
  heute.setDate(heute.getDate() + offset);
  const heute_wt = heute.getDay() === 0 ? 7 : heute.getDay();
  let diff = wochentag - heute_wt;
  if (diff < 0) diff += 7;
  const d = new Date(heute);
  d.setDate(d.getDate() + diff);
  return d;
}

export default function Fahrer() {
  const { user }   = useAuth();
  const navigate   = useNavigate();

  const [touren,       setTouren]       = useState([]);
  const [aktiveTour,   setAktiveTour]   = useState(null);
  const [aktivDatum,   setAktivDatum]   = useState(null);
  const [lieferungen,  setLieferungen]  = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [loadingLief,  setLoadingLief]  = useState(false);
  const [optimizing,   setOptimizing]   = useState(false);

  useEffect(() => {
    if (!user || (user.rolle !== "Fahrer" && user.rolle !== "Admin" && !user.isAdmin)) {
      navigate("/"); return;
    }
    api.touren.getAll().then(t => {
      setTouren(t.filter(x => x.istAktiv));
      // Automatisch heutige Tour vorauswählen falls vorhanden
      const heute = new Date();
      const heute_wt = heute.getDay() === 0 ? 7 : heute.getDay();
      const heutigeTour = t.find(tour =>
        tour.wochentage.split(",").map(Number).includes(heute_wt)
      );
      if (heutigeTour) {
        setAktiveTour(heutigeTour);
        setAktivDatum(toLocalISO(heute));
      }
    }).finally(() => setLoading(false));
  }, [user, navigate]);

  useEffect(() => {
    if (!aktiveTour || !aktivDatum) return;
    setLoadingLief(true);
    api.touren.getLieferungen(aktiveTour.tourId, aktivDatum)
      .then(setLieferungen)
      .finally(() => setLoadingLief(false));
  }, [aktiveTour, aktivDatum]);

  const handleOptimieren = async () => {
    if (!aktiveTour) return;
    setOptimizing(true);
    try {
      if (aktiveTour.gruppeId) {
        await api.touren.gruppeOptimieren(aktiveTour.gruppeId);
      } else {
        await api.touren.optimieren(aktiveTour.tourId);
      }
      const fresh = await api.touren.getLieferungen(aktiveTour.tourId, aktivDatum);
      setLieferungen(fresh);
    } catch { alert("Fehler beim Optimieren."); }
    finally { setOptimizing(false); }
  };

  if (loading) return <div className="container" style={{ paddingTop: "3rem", textAlign: "center" }}>Lädt...</div>;

  // Alle Tage aufbauen: für jede Tour alle Wochentage der nächsten 7 Tage
  const tageOptionen = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    const wt = d.getDay() === 0 ? 7 : d.getDay();
    const tourenHeute = touren.filter(t => t.wochentage.split(",").map(Number).includes(wt));
    if (tourenHeute.length > 0) {
      tageOptionen.push({ datum: toLocalISO(d), d, wt, touren: tourenHeute });
    }
  }

  return (
    <div className="container" style={{ maxWidth: 1000 }}>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem", margin: "1.5rem 0" }}>
        <button onClick={() => navigate(-1)} style={{ background: "none", border: "1.5px solid #e0e0e0", borderRadius: "8px", padding: "0.4rem 0.9rem", cursor: "pointer", color: "#555", fontSize: "0.9rem", flexShrink: 0 }}>
          ← Zurück
        </button>
        <div style={{ width: 50, height: 50, borderRadius: "50%", background: "linear-gradient(135deg, #e65100, #ff9800)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem", flexShrink: 0 }}>🚚</div>
        <div>
          <h2 style={{ color: "#e65100", margin: 0 }}>Fahrer – Lieferplan</h2>
          <p style={{ color: "#888", margin: 0, fontSize: "0.9rem" }}>Hallo {user?.vorname}! Wähle Tour und Datum.</p>
        </div>
      </div>

      {/* ── Tour + Datum Auswahl ── */}
      <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginBottom: "1.5rem" }}>
        {tageOptionen.map(tag => (
          tag.touren.map(tour => {
            const isAktiv = aktiveTour?.tourId === tour.tourId && aktivDatum === tag.datum;
            return (
              <button key={`${tour.tourId}-${tag.datum}`}
                onClick={() => { setAktiveTour(tour); setAktivDatum(tag.datum); }}
                style={{
                  padding: "0.5rem 1rem",
                  borderRadius: "10px",
                  border: `2px solid ${isAktiv ? tour.farbe : "#ddd"}`,
                  background: isAktiv ? tour.farbe : "white",
                  color: isAktiv ? "white" : "#333",
                  fontWeight: isAktiv ? 700 : 400,
                  cursor: "pointer",
                  fontSize: "0.9rem",
                  transition: "all 0.15s",
                }}>
                <div style={{ fontSize: "0.75rem", opacity: isAktiv ? 0.85 : 0.6 }}>
                  {tag.d.toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit" })}
                  {tag.d.toDateString() === new Date().toDateString() && " · Heute"}
                </div>
                <div>🗺️ {tour.name}</div>
              </button>
            );
          })
        ))}
      </div>

      {/* ── Lieferungen ── */}
      {aktiveTour && aktivDatum ? (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "0.5rem", flexWrap: "wrap" }}>
            <h3 style={{ color: aktiveTour.farbe, margin: 0 }}>
              🚚 Tour {aktiveTour.name} – {new Date(aktivDatum + "T12:00:00").toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "long" })}
              {!loadingLief && <span style={{ marginLeft: "0.75rem", fontSize: "0.9rem", color: "#888", fontWeight: 400 }}>({new Set(lieferungen.map(l => l.userId)).size} Stopps)</span>}
            </h3>
            <button onClick={handleOptimieren} disabled={optimizing || loadingLief} style={{
              padding: "0.4rem 1rem", borderRadius: 8,
              border: "1.5px solid #e65100",
              background: optimizing ? "#eee" : "#fff3e0",
              color: "#e65100", cursor: optimizing ? "default" : "pointer", fontSize: "0.88rem", fontWeight: 600,
            }}>
              {optimizing ? "⏳ Optimiere..." : "🗺️ Route optimieren"}
            </button>
          </div>
          {loadingLief
            ? <div style={{ textAlign: "center", color: "#888", padding: "2rem" }}>Lädt Lieferungen...</div>
            : <FahrerKarte lieferungen={lieferungen} datum={new Date(aktivDatum)} mapId={`karte-${aktiveTour.tourId}-${aktivDatum}`} tourFarbe={aktiveTour.farbe} />
          }
        </div>
      ) : (
        <div className="card" style={{ textAlign: "center", color: "#aaa", padding: "3rem" }}>
          Heute keine Tour geplant – wähle oben ein Datum.
        </div>
      )}
    </div>
  );
}
